(function () {
  'use strict';
  if (window.VariantWarehouseBadges) return;

  // Ella also nests grouped products inside a form and clones cart-edit product blocks.
  var scopeSelector = '[data-warehouse-inventory-scope]';
  var dataSelector = '[data-warehouse-variants]';
  var badgeSelector = '[data-warehouse-badge]';
  var optionSelector = '.swatch[data-option-index]';
  var masterSelector = 'select[name="id"], input[name="id"], select[name="group_id"], input[name="group_id"], select[data-select-change-variant]';
  var controlSelector = '.swatch input[type="radio"], .swatch label, .single-option-selector, ' + masterSelector;
  var jsonCache = new WeakMap();
  var refreshTimers = new WeakMap();
  var selectionSources = new WeakMap();

  function ownElements(scope, selector) {
    return Array.prototype.filter.call(scope.querySelectorAll(selector), function (element) {
      return element.closest(scopeSelector) === scope;
    });
  }

  function readJSON(element, fallback) {
    if (!element) return fallback;
    var source = element.textContent;
    var cached = jsonCache.get(element);
    if (cached && cached.source === source) return cached.value;
    var value;
    try { value = JSON.parse(source); } catch (error) { value = fallback; }
    jsonCache.set(element, { source: source, value: value });
    return value;
  }

  function hasStock(warehouse) {
    if (!warehouse || typeof warehouse !== 'object') return false;
    var status = String(warehouse.status || '').trim().toLowerCase();
    if (status !== 'available' && status !== '可用') return false;
    var quantity = warehouse.quantity;
    if (typeof quantity !== 'number' && typeof quantity !== 'string') return false;
    if (typeof quantity === 'string' && !/^-?\d+(?:\.\d+)?$/.test(quantity.trim())) return false;
    return isFinite(Number(quantity)) && Number(quantity) > 0;
  }

  function resolveWarehouseBadge(warehouses) {
    if (!warehouses || typeof warehouses !== 'object') return '';
    if (hasStock(warehouses.us)) return 'us';
    if (hasStock(warehouses.local)) return 'local';
    return '';
  }

  function findVariant(variants, options) {
    var found = null;
    for (var index = 0; index < variants.length; index++) {
      var candidate = variants[index];
      if (!Array.isArray(candidate.options) || candidate.options.length !== options.length) continue;
      var matches = options.every(function (value, optionIndex) {
        return typeof value === 'string' && value !== '' && value === candidate.options[optionIndex];
      });
      if (matches) {
        if (found) return null; // Ambiguous combinations must never borrow inventory.
        found = candidate;
      }
    }
    return found;
  }

  function selectedOptions(scope, variants) {
    var field = ownElements(scope, masterSelector)[0];
    var selected = variants.filter(function (variant) { return field && String(variant.id) === field.value; });
    var options = selected.length === 1 ? selected[0].options.slice() : [];
    if (!field && variants.length === 1) options = variants[0].options.slice();
    var optionCount = variants.reduce(function (count, variant) { return Math.max(count, variant.options.length); }, 0);
    var seen = {};
    var source = selectionSources.get(scope);

    function readSwatches() {
      ownElements(scope, optionSelector).forEach(function (swatch) {
        var index = Number(swatch.getAttribute('data-option-index'));
        var checked = swatch.querySelector('input[type="radio"]:checked');
        if (checked && index >= 0 && index < optionCount) options[index] = checked.value;
      });
    }

    // An explicit master-ID change is authoritative even if Ella's mirrored radios lag.
    if (source === 'id') {
      for (var index = 0; index < optionCount; index++) {
        if (typeof options[index] !== 'string') options[index] = '';
      }
      return options;
    }
    if (source === 'selectors') readSwatches();

    ownElements(scope, '.single-option-selector').forEach(function (control, position) {
      var attribute = control.getAttribute('data-option') || control.getAttribute('data-index') || '';
      var namedIndex = /^option(\d+)$/.exec(attribute);
      var idIndex = /-option-(\d+)$/.exec(control.id);
      var index = namedIndex ? Number(namedIndex[1]) - 1 : idIndex ? Number(idIndex[1]) : position;
      var explicit = control.getAttribute('data-option-index');
      if (explicit !== null) index = Number(explicit);
      // The slider layout has an extra legacy selector with the same index. Read the first one.
      if (index >= 0 && index < optionCount && !seen[index]) {
        options[index] = control.value || '';
        seen[index] = true;
      }
    });

    // Preserve the actual event's source when the two sets of controls temporarily disagree.
    if (source !== 'selectors') readSwatches();
    for (var index = 0; index < optionCount; index++) {
      if (typeof options[index] !== 'string') options[index] = '';
    }
    return options;
  }

  function renderBadge(badge, kind, assets) {
    var src = kind && assets && assets[kind];
    if (typeof src !== 'string' || !src.trim()) {
      badge.replaceChildren();
      badge.hidden = true;
      badge.removeAttribute('data-warehouse-kind');
      return false;
    }
    var image = badge.querySelector('img');
    if (!image || badge.getAttribute('data-warehouse-kind') !== kind || image.getAttribute('src') !== src) {
      image = document.createElement('img');
      image.alt = kind === 'us' ? 'US Warehouse' : '48hrs';
      image.draggable = false;
      image.addEventListener('error', function () {
        if (image.parentNode === badge) {
          badge.replaceChildren();
          badge.hidden = true;
          badge.removeAttribute('data-warehouse-kind');
          var option = badge.closest('.swatch-element');
          if (option) option.classList.remove('has-warehouse-badge');
          var single = badge.closest('[data-warehouse-single]');
          if (single) single.hidden = true;
        }
      });
      image.src = src;
      badge.replaceChildren(image);
    }
    badge.setAttribute('data-warehouse-kind', kind);
    badge.hidden = false;
    return true;
  }

  function refreshScope(scope) {
    if (!scope.isConnected) return;
    var variants = readJSON(ownElements(scope, dataSelector)[0], []);
    variants = Array.isArray(variants) ? variants.filter(function (variant) {
      return variant && variant.id != null && Array.isArray(variant.options);
    }) : [];
    var assets = readJSON(ownElements(scope, '[data-warehouse-assets]')[0], {});
    var options = selectedOptions(scope, variants);
    var targets = ownElements(scope, '.swatch[data-warehouse-option][data-option-index]');
    var standalone = variants.length === 1 || targets.length === 0;

    targets.forEach(function (swatch) {
      var optionIndex = Number(swatch.getAttribute('data-option-index'));
      Array.prototype.forEach.call(swatch.querySelectorAll('.swatch-element'), function (element) {
        var badge = element.querySelector(badgeSelector);
        if (!badge) return;
        var combination = options.slice();
        combination[optionIndex] = element.getAttribute('data-value');
        var variant = findVariant(variants, combination);
        var kind = !standalone && variant ? resolveWarehouseBadge(variant.warehouses) : '';
        element.classList.toggle('has-warehouse-badge', renderBadge(badge, kind, assets));
      });
    });

    var current = findVariant(variants, options);
    ownElements(scope, '[data-warehouse-single]').forEach(function (container) {
      var badge = container.querySelector(badgeSelector);
      var kind = standalone && current ? resolveWarehouseBadge(current.warehouses) : '';
      container.hidden = !badge || !renderBadge(badge, kind, assets);
    });
  }

  function refresh(root) {
    if (!root || !root.querySelectorAll) root = document;
    var scope = root.closest && root.closest(scopeSelector);
    if (scope) refreshScope(scope);
    Array.prototype.forEach.call(root.querySelectorAll(scopeSelector), refreshScope);
  }

  function schedule(scope, source) {
    if (!scope) return;
    if (source) selectionSources.set(scope, source);
    var previous = refreshTimers.get(scope) || [];
    previous.forEach(window.clearTimeout);
    refreshTimers.set(scope, [0, 80].map(function (delay) {
      return window.setTimeout(function () { refreshScope(scope); }, delay);
    }));
  }

  function handleControl(event) {
    var target = event.target;
    var control = target && target.closest && target.closest(controlSelector);
    if (!control) return;
    var source = control.matches('.single-option-selector') ? 'selectors' :
      control.matches(masterSelector) ? 'id' : 'swatches';
    schedule(control.closest(scopeSelector), source);
  }

  document.addEventListener('click', handleControl, true);
  document.addEventListener('change', handleControl, true);
  document.addEventListener('warehouse-inventory:variant-change', function (event) {
    var scope = event.target.closest && event.target.closest(scopeSelector);
    // The callback has just mirrored the controls; discard any earlier master-ID override.
    function callbackRefresh(instance) {
      schedule(instance, ownElements(instance, '.single-option-selector').length ? 'selectors' : 'swatches');
    }
    if (scope) callbackRefresh(scope);
    else Array.prototype.forEach.call(document.querySelectorAll(scopeSelector), callbackRefresh);
  });
  document.addEventListener('shopify:section:load', function (event) { refresh(event.target); });

  function start() {
    refresh();
    // Ella uses jQuery.trigger('change'), which does not dispatch a native DOM change.
    if (window.jQuery) window.jQuery(document).on('change.warehouseInventory', controlSelector, handleControl);
    // Discover inserted/replaced forms and generated OptionSelectors. Ignore our image updates.
    var pending;
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        if (target && target.closest(badgeSelector)) return false;
        if (target && target.closest(scopeSelector)) return true;
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches(scopeSelector) || node.querySelector(scopeSelector));
        });
      });
      if (relevant) {
        window.clearTimeout(pending);
        pending = window.setTimeout(refresh, 0);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  window.VariantWarehouseBadges = { refresh: refresh, resolveWarehouseBadge: resolveWarehouseBadge };
  window.refreshVariantWarehouseBadges = refresh;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('load', function () { refresh(); });
})();
